<script setup>
  import { computed, watch, ref } from 'vue'
  import MultistepInput from '@/components/Form/MultistepInput.vue'
  import MultistepFormActions from '@/components/Form/MultistepFormActions.vue'

  const emit = defineEmits(['updateValue', 'back', 'next', 'submitStep'])

  const props = defineProps({
    data: {
      type: Object,
      required: true
    },
    values: {
      type: Object,
      default: () => ({})
    },
    canGoBack: {
      type: Boolean,
      default: false
    },
    isLastStep: {
      type: Boolean,
      default: false
    },
    nextLabel: {
      type: String,
      required: true
    },
    previousLabel: {
      type: String,
      required: true
    },
    submitLabel: {
      type: String,
      required: true
    },
    stepError: {
      type: Boolean,
      default: false
    },
    stepErrorMessage: {
      type: String,
      default: ''
    }
  })

  const formSchema = computed(() => {
    const elements = props.data.elements

    elements.forEach((element, index) => {
      if (element.name === 'company') {
        isCompany.value ? (element.required = true) : (element.required = false)
      }
      if (hideIfPrivate.includes(element.name)) {
        if (isCompany.value) {
          element.hidden = false
          element.required = true
        } else {
          element.hidden = true
          element.required = false
        }
      }
    })

    return elements
  })

  const isCompany = computed(() => {
    if (!props.values.customer_type) {
      return false
    }
    return props.values.customer_type === 'company'
  })

  const hideIfPrivate = [
    'contact_name',
    'contact_department',
    'contact_email',
    'contact_phone',

  ]

const getHeadline = computed(() => {
  let text = 'Empty'
  props.data.elements.forEach((element) => {
    if (element.type === 'webform_markup') {
      text = element.markup
    }
  })
  return text
})

const updateValue = (field, value) => {
  emit('updateValue', field, value)
}

const handleNextStep = () => {
  emit('next')
}

const handleSubmitStep = () => {
  emit('submitStep')
}
</script>

<template>
<div
    class="order-form"
  >
    <GridLayout
      hasGap
    >
      <LeftHeadline
        :text="getHeadline"
      />
      <div
        class="order-form-form lg:col-span-8 flex flex-col lg:grid lg:grid-cols-2 ~gap-6/8"
      >
        <MultistepInput
          v-for="(field, key) in formSchema"
          @updateValue="updateValue"
          :key="key"
          :data="field"
          :name="field.name"
          :model-value="values[field.name]"
        />
        <div class="step-headline col-span-2">
          <MultistepFormActions
            :can-go-back="canGoBack"
            :is-last-step="isLastStep"
            :next-label="nextLabel"
            :previous-label="previousLabel"
            :submit-label="submitLabel"
            :step-error="stepError"
            :step-error-message="stepErrorMessage"
            @back="emit('back')"
            @next="handleNextStep"
            @submit="handleSubmitStep"
          />
        </div>
      </div>
    </GridLayout>
  </div>

</template>

<style lang="scss" scoped>
.step-headline {
  @apply mt-6 flex flex-col lg:flex-row lg:justify-end mb-8;
}

</style>
